import { useDispatch, useSelector } from 'react-redux';

import { productManagementActions } from '../../store/product-management-slice';
import { Textarea } from '../Textarea/Textarea';

import styles from './addProductModalTabs.module.css';

export const BeschreibungTab = () => {
    const dispatch = useDispatch();
    const product = useSelector((state: any) => state.productManagement.product);

    const handleDescriptionChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        dispatch(productManagementActions.setDescription(event.target.value));
    };
    const handleInternalNoteChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        dispatch(productManagementActions.setInternalNote(event.target.value));
    };

    return (
        <div className={styles["tab-beschreibung"]}>
            <Textarea
                label="Produktbeschreibung"
                value={product.description}
                disabled={product.isFromSevDesk}
                onChange={handleDescriptionChange}
            />
            <Textarea
                label="Interne Bemerkung"
                value={product.internalNote}
                disabled={product.isFromSevDesk}
                onChange={handleInternalNoteChange}
            />
        </div>
    );
}